import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { RootState } from "@/redux/rootReducer";
import { PATH_APP } from "@/routes/paths";
import { getAccessToken } from "@/utils/auth";

export const checkAuth = () => {
	const { isAuthenticated } = useSelector((state: RootState) => state.auth);
	const { pathname } = useLocation();
	const history = useHistory();

	useEffect(() => {
		if (!getAccessToken()) {
			history.replace(PATH_APP.auth.login);
		}
	}, [isAuthenticated, pathname]);
};
